import React, { useEffect, useState } from "react";

import { SiSpeedtest } from "react-icons/si";
import { FaRegCalendarAlt } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { Link } from "react-router-dom";

import styles from "./OperateCard.module.css";

import ServiceIcon from "../../operate/card-two-side/service-icon";
import RemainingWS from "../../operate/card-two-side/remaining-ws";
import RemainingTS from "../../operate/card-two-side/remaining-ts";

import { parseLocalizedNumber } from "../../../services/functions";

const OperateCard = ({
    service,
    min,
    max,
    now,
}) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (
            typeof min !== "number" ||
            typeof max !== "number" ||
            typeof now !== "number" ||
            max <= min
        ) {
            setProgress(0);
            return;
        }

        const percentage =
            ((now - min) / (max - min)) * 100;

        setProgress(
            Math.min(
                Math.max(percentage, 0),
                100
            )
        );
    }, [now, min, max]);

    const remain = parseLocalizedNumber(
        service?.remain
    );

    const isOverdue =
        Number(
            parseLocalizedNumber(service?.remain)
        ) < 0;

    return (
        <article
            className={`${styles.card} ${
                isOverdue ? styles.overdueCard : ""
            }`}
            dir="rtl"
        >
            {/* Header */}
            <header className={styles.header}>
                <div className={styles.serviceInfo}>
                    <ServiceIcon
                        categoryId={service?.ok_id}
                    />

                    <div className={styles.titleWrapper}>
                        <div className={styles.serviceTitle}>
                            {service?.opTitle}
                        </div>

                        <div className={styles.carTitle}>
                            {service?.car_title}
                        </div>
                    </div>
                </div>

                <div className={styles.typeIcon}>
                    {service?.ok_serviceType === "km" ? (
                        <SiSpeedtest size={18} />
                    ) : (
                        <FaRegCalendarAlt size={18} />
                    )}
                </div>
            </header>

            {/* Circular Progress */}
            <div className={styles.progressSection}>
                <div
                    className={`${styles.circularProgress} ${
                        isOverdue
                            ? styles.overdue
                            : ""
                    }`}
                    style={{
                        "--progress": `${progress}%`,
                    }}
                    role="progressbar"
                    aria-valuenow={progress}
                    aria-valuemin="0"
                    aria-valuemax="100"
                >
                    <span className={styles.progressValue}>
                        {Math.round(progress)}٪
                    </span>
                </div>

                <div
                    className={`${styles.remainingTitle} ${
                        isOverdue
                            ? styles.overdueText
                            : ""
                    }`}
                >
                    مانده تا سرویس بعدی
                </div>

                <div
                    className={`${styles.remainingValue} ${
                        isOverdue
                            ? styles.overdueText
                            : ""
                    }`}
                >
                    {service?.ok_serviceType === "km" ? (
                        <RemainingWS
                            remain={service?.remain}
                        />
                    ) : (
                        <RemainingTS
                            remain={service?.remain}
                        />
                    )}
                </div>
            </div>

            {/* Done Button */}
            <Link
                className={styles.doneButton}
                to="/oper-reg"
                state={service}
                title="ثبت سرویس انجام شده"
            >
                <CiEdit size={19} />
                <span>انجام شد</span>
            </Link>
        </article>
    );
};

export default OperateCard;
